export const Logo = ({ size = 38 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Beylikdüzü Elektrikçi logo"
    data-testid="site-logo"
  >
    <rect width="40" height="40" rx="10" fill="#0F172A" stroke="#F59E0B" strokeWidth="2" />
    <path
      d="M13 10H23C25.5 10 27 11.5 27 13.5C27 15.2 25.8 16.5 24 17C26.2 17.6 27.5 19.2 27.5 21.5C27.5 24 25.5 25.5 22.5 25.5H13V10Z"
      stroke="#F8FAFC"
      strokeWidth="2.5"
      strokeLinejoin="round"
    />
    <path d="M20 7L14 20H20L18 29L26 16H20L22 7H20Z" fill="#F59E0B" />
  </svg>
);
